import { adaloBackendAxios } from 'utils/io/http/axios'

const REQUEST_USER = 'REQUEST_USER'
const DELETE_USER = 'DELETE_USER'
const UNSUBSCRIBE_USER_FROM_MARKETING = 'UNSUBSCRIBE_USER_FROM_MARKETING'

const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action) => {
  if (action.type === `${REQUEST_USER}_FULFILLED`) {
    return {
      ...state,
      [action.meta.userId]: action.payload.data,
    }
  }

  if (action.type === `${DELETE_USER}_FULFILLED`) {
    // Mark user as deleted in state
    const userId = action.meta.userId
    const existingUser = state[userId]
    if (existingUser) {
      return {
        ...state,
        [userId]: {
          ...existingUser,
          deleted: true,
          deletedAt: new Date().toISOString(),
          deletionResult: action.payload.data.result,
        },
      }
    }

    return state
  }

  if (action.type === `${UNSUBSCRIBE_USER_FROM_MARKETING}_FULFILLED`) {
    // Mark user as unsubscribed from marketing
    const userId = action.meta.userId
    const existingUser = state[userId]
    if (existingUser) {
      return {
        ...state,
        [userId]: {
          ...existingUser,
          marketingUnsubscribed: true,
          marketingUnsubscribedAt: new Date().toISOString(),
          marketingUnsubscribeResult: action.payload.data.result,
        },
      }
    }

    return state
  }

  return state
}

// Actions

export const requestUser = userId => ({
  type: REQUEST_USER,
  payload: adaloBackendAxios.get(`/users/${userId}`),
  meta: { userId },
})

export const deleteUser = userId => ({
  type: DELETE_USER,
  payload: adaloBackendAxios.delete(`/admin/users/${userId}`),
  meta: { userId },
})

export const unsubscribeUserFromMarketing = userId => ({
  type: UNSUBSCRIBE_USER_FROM_MARKETING,
  payload: adaloBackendAxios.post(`/admin/users/${userId}/unsubscribe`),
  meta: { userId },
})
// Selectors

export const getUser = (state, userId) => {
  return state.admin.users[userId]
}

export const isUserDeleted = (state, userId) => {
  const user = getUser(state, userId)

  return user && user.deleted
}

export const isUserMarketingUnsubscribed = (state, userId) => {
  const user = getUser(state, userId)

  return user && user.marketingUnsubscribed
}
